var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-full-video"},[_c('div',{staticClass:"video-container"},[_c('vimeo-embed',{attrs:{"button":true,"video":_vm.video},on:{"end":function($event){return _vm.$emit('done')}}})],1),_c('p',{on:{"click":function($event){return _vm.$emit('done')}}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }